import { LazyLoadedDevTools } from '@quickmd-llc/design-system'
import { isDevToolsEnabled } from 'features/isDevToolsEnabled'
import env from '../../env.json'

// Static environment data — no provider dependencies
const staticEnvironmentData = {
  App: 'provider',
  Environment: env.name,
  'API URL': env.baseURL,
}

/**
 * DevTools shell — renders outside error boundaries for crash resilience.
 * Console, network, storage, and environment panels survive app crashes.
 */
export function DevToolsShell() {
  return (
    <span className='tailwind-scoped'>
      <LazyLoadedDevTools isDevToolsEnabled={isDevToolsEnabled} environmentData={staticEnvironmentData} />
    </span>
  )
}
